<template>
    <div class="container dropdown-container">
        <h1>{{msg}}</h1>
        <div class="row">
            <div class="col">

                <div class="dropdown dropdown-custom">
                    <button class="button__raw dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Pascal Plüss
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item active" href="#">Einstellungen</a>
                        <a class="dropdown-item" href="#">Meine Daten</a>
                        <a class="dropdown-item" href="#">Logut</a>
                    </div>
                </div>

            </div>
            <div class="col">

                <div class="dropdown dropdown-custom show">
                    <button class="button__raw dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Pascal Plüss
                    </button>
                    <div class="dropdown-menu show" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item active" href="#">Einstellungen</a>
                        <a class="dropdown-item" href="#">Meine Daten</a>
                        <a class="dropdown-item" href="#">Logut</a>
                    </div>
                </div>

            </div>
        </div>

        <div class="row mt-30vh">
            <div class="col">
                <div class="dropdown dropdown-custom dropdown-custom--wider">
                    <button class="button__raw dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Pascal Plüss
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item active" href="#">Einstellungen</a>
                        <a class="dropdown-item" href="#">Meine Daten</a>
                        <a class="dropdown-item" href="#">Logut</a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="dropdown dropdown-custom dropdown-custom--wider show">
                    <button class="button__raw dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Pascal Plüss
                    </button>
                    <div class="dropdown-menu show" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item active" href="#">Einstellungen</a>
                        <a class="dropdown-item" href="#">Meine Daten</a>
                        <a class="dropdown-item" href="#">Logut</a>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
    export default {
        name: "Dropdowns",
        data() {
            return {
                msg: 'Dropdowns'
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/mixins";
    @import "../assets/scss/variables";

    .mt-30vh {
        margin-top: 30vh;
    }

    .dropdown-container {
        padding: 3rem 0;
        height: 100vh;
    }

    .dropdown-custom {
        &.show {
            .dropdown-toggle {
                border-color: #ccc;
                background: white;
                @include base-box-shadow();
                color: $alert-blue;

                &:after {
                    border-top: .3em solid transparent;
                    border-right: .3em solid transparent;
                    border-bottom: .3em solid;
                    border-left: .3em solid transparent;
                }
            }
        }
        .dropdown {
            &-toggle {
                min-width: 10rem;
                padding: .25rem 1.57rem;

                &:focus {
                    outline: 0;
                }
            }
            &-menu {
                @include base-box-shadow();
                margin-top: 1px;
                border: 0;

                .dropdown-item.active {
                    background-color: $alert-light-gray;
                    color: #000;
                }

            }
        }

        .dropdown-menu {
            z-index: 18;
        }


        &--wider {
            width: 100%;

            .dropdown-toggle {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .dropdown-menu {
                width: 100%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Dropdowns.vue